import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AnalyticsRoot } from './components/AnalyticsRoot';
import { TagManagerRoot } from './components/TagManagerRoot';
import { ErrorBoundary } from './components/error/ErrorBoundary';
import { NotFound } from './components/error/NotFound';
import { LoginComponent } from './components/login/LoginComponent';
import { VStack } from '@bpba/ui-components';
import { SignUpUserForm } from './Login/SignUpUserForm';
import { SignUpAddressForm } from './Login/SignUpAddressForm';
import { FixedTermsList } from './FixedTerm/FixedTermsList';
import { FixedTermSimulatorForm } from './FixedTerm/FixedTermSimulatorForm';
import { FixedTermNew } from './FixedTerm/FixedTermNew';
import { OTPForm } from './Login/OTPForm';
import { FixedTermConfirm } from './FixedTerm/FixedTermConfirm';
import { UrlsFront } from './constants/urls';
import { DebinConfirm } from './components/debin/DebinConfirm';
import { LayoutLoginSingUp } from './components/shared/layout/LayoutLoginSingUp';
import { MenuProvider } from './components/MenuContext';
import { AuthorizedLayout } from './components/shared/layout/AuthorizedLayout';

const HOME_PATH = process.env.REACT_APP_HOME_PATH ? process.env.REACT_APP_HOME_PATH : '';

const App = () => {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ErrorBoundary backupComponent={<NotFound />}>
        <AnalyticsRoot />
        <TagManagerRoot />
        <MenuProvider>
          <VStack>
            <Routes>
              {HOME_PATH.length > 0 && <Route path="/" element={<Navigate to={HOME_PATH} />} />}
              <Route element={<LayoutLoginSingUp />}>
                <Route path={UrlsFront.LogIn} element={<LoginComponent />} />
                <Route path={UrlsFront.SignUpHome} element={<SignUpUserForm />} />
                <Route path={UrlsFront.SignUpValidate} element={<OTPForm />} />
                <Route path={UrlsFront.SignUpContact} element={<SignUpAddressForm />} />
              </Route>
              <Route path={UrlsFront.FixedTerms} element={<AuthorizedLayout />}>
                <Route path="" element={<FixedTermsList />} />
                <Route path={UrlsFront.FixedTermSimulation} element={<FixedTermSimulatorForm />} />
                <Route path={UrlsFront.FixedTermNew} element={<FixedTermNew />} />
                <Route path={UrlsFront.FixedTermAccept} element={<FixedTermConfirm />} />
                <Route path={UrlsFront.DebinConfirm} element={<DebinConfirm />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </VStack>
        </MenuProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
